import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useCartState } from '@/hooks/useCart';
import { useUIStore } from '@/store/uiStore';
import { motion } from 'framer-motion';

export const CartIcon = () => {
  const { itemCount } = useCartState();
  const openCartDrawer = useUIStore((state) => state.openCartDrawer);

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={openCartDrawer}
      className="relative hover:bg-gray-100 transition-colors"
      aria-label="Shopping cart"
    >
      <ShoppingCart className="w-6 h-6 text-gray-900" />
      {itemCount > 0 && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute -top-1 -right-1"
        >
          <Badge className="bg-brand-accent text-white h-5 min-w-5 px-1 rounded-full flex items-center justify-center text-xs font-bold shadow-lg">
            {itemCount}
          </Badge>
        </motion.div>
      )}
    </Button>
  );
};
